import { render } from "./BlogList.vue?vue&type=template&id=47f4fe03&scoped=true&bindings={\"isLoaded\":\"setup\",\"articles\":\"setup\"}"
import script from "./BlogList.vue?vue&type=script&lang=js"
export * from "./BlogList.vue?vue&type=script&lang=js"

import "./BlogList.vue?vue&type=style&index=0&id=47f4fe03&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-47f4fe03"

export default script